<template>
  <div v-if="resumeCon.length" class="jin-form-warp">
    <div v-for="(item) in resumeCon" :ref="item.parent" :key="item.title" class="jin-form-template">
      <FormHead :info="item" />
      <component :is="item.template" v-if="item.template" :ref="item.template" :info="item" @autoSave="autoSave" />
    </div>
    <div class="jin-resume-submit">
      <el-button :disabled="disabled" :loading="loading" @click="submit">{{ btnName }}</el-button>
    </div>
  </div>
</template>

<script>
import { BaseUp, Resume, AttachUp, BaseOn, Edu, Work, Project, Grade, Attach } from './index'
import { resumeApi } from '@/api'
import { throttle } from '@/utils'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  components: {
    BaseUp, AttachUp, Resume, BaseOn, Edu, Work, Project, Grade, Attach
  },
  data() {
    return {
      fixNum: 0,
      loading: false,
      btnName: '确认投递',
      disabled: false,
      isAuto: true
    }
  },
  computed: {
    ...mapGetters([
      'resume',
      'resumeList',
      'currForm',
      'resumeCon',
      'submitForm',
      'drafts'
    ]),
    id() {
      return this.$route.query.id
    },
    type() {
      return this.$route.query.type
    }
  },
  watch: {
    resumeList: {
      handler() {
        this.resetBtn()
      },
      deep: true
    },
    resumeCon: {
      handler() {
        this.fixNum++
        if (this.IsPC && this.isAuto && this.fixNum > 1) this.autoSave()
      },
      deep: true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapActions('resume', ['GET_RESUMR_LIST', 'GET_DRAFT']),
    ...mapMutations('resume', ['SET_FORM', 'RESET_FORM']),
    init() {
      if (this.resumeCon.length) {
        this.$emit('onActive', this.resumeCon[0].title, 'upload')
        window.addEventListener('scroll', this.handleScrollx, true)
        this.resetBtn()
      }
    },
    autoSave() {
      throttle(async() => {
        this.SET_FORM(this.resumeCon)
        await resumeApi.addDraft(this.currForm)
        this.init()
      }, 1000)
    },
    handleScrollx() {
      // 滚动定位到左侧sidebar的title
      this.resumeCon.map(item => {
        if (this.$refs[item.parent] && this.$refs[item.parent][0] && this.$refs[item.parent][0].getBoundingClientRect && this.$refs[item.parent][0].getBoundingClientRect().top < 60) {
          this.$emit('onActive', item.title, 'upload')
        }
        return item
      })
    },
    resetBtn() {
      if (this.resumeList.find(item => Number(item.target_id) === Number(this.id))) {
        this.disabled = true
        this.btnName = '已投递'
      }
    },
    async submit() {
      // this.SET_FORM(this.resumeCon)
      await this.GET_DRAFT({ type: this.type })
      if (this.$refs.BaseUp && this.$refs.BaseUp[0].submitForm()) {
        if (!(this.currForm.resume && this.currForm.resume.url)) return this.$message.error('请上传简历')
        this.$confirm('投递简历后将不能修改该简历，是否马上投递?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(async() => {
            this.RESET_FORM(this.drafts)
            const curr = this.submitForm
            this.loading = true
            this.isAuto = false
            this.fixNum = 0
            const res = await resumeApi.submit({ ...curr, target_id: +this.id, type: 1 })
            await resumeApi.deleteDraft()
            this.Toast(res.message)
            setTimeout(() => {
              window.location.reload()
            }, 500)
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.jin {
  &-form-warp {
    padding: 40px 40px 40px 0;
    width: 790px;

    /deep/ .el-form {
      padding: 30px 20px;

      &-item:nth-last-of-type(1) {
        margin-bottom: 0;
      }
    }
  }

  &-resume-submit {
    height: 72px;

    &::before {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      width: 1000px;
      height: 1px;
      background: #e8e8ea;
    }

    /deep/ .el-button {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      display: block;
      width: 150px;
      height: 42px;
      background: #4777f4;
      border-radius: 24px;
      color: #fff;
      margin-top: 30px;
    }
  }
}
</style>
